import { faSquarespace } from '@fortawesome/free-brands-svg-icons';
import { faMinus, faSearch, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Form, Table } from "react-bootstrap";
import { useToasts } from 'react-toast-notifications'
import React, { useEffect, useState } from 'react'
import { imageRender } from '../../../helpers';
import { COLOR_APP_CANCEL } from '../../../constants'; 

export default function SelectedProduct({ liveStock, setLiveStock, removeStockFromLive, handleRemoveLiveStockAll }) {
    const { addToast } = useToasts()

    console.log({liveStock})

    const _liveStockChange = (stock, index, e, isRemoved) => {
        let _liveStock = [...liveStock]

        if (isRemoved) {
            _liveStock[index] = {
                ..._liveStock[index],
                amount: parseInt(stock?.amount) - 1,
                amountAll: parseInt(stock?.amount) - 1
            };
            //Check amount is less than 1
            if (parseInt(stock?.amount) <= 1) {
                addToast("ຈໍານວນຕ້ອງການຂາຍຫຼາຍກວ່າຫນຶ່ງຊິ້ນ!", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                return
            }
        }

        if (!isRemoved) {
            _liveStock[index] = {
                ..._liveStock[index],
                amount: parseInt(stock?.amount) + 1,
                amountAll: parseInt(stock?.amount) + 1
            }
            //Check amount is less than stock
            if (_liveStock[index].validateAmount + _liveStock[index]?.stock?.amount <= parseInt(stock?.amount)) {
                addToast("ຈໍານວນຂາຍຕ້ອງບໍ່ເກີນໃນສະຕ໋ອກ!", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                return
            }
        }

        setLiveStock(_liveStock)
    }
    return (
        <div style={{ display: 'flex', flexDirection: "column", width: '100%', marginTop: 10 }}>
            <div style={{ display: 'flex', flexDirection: "row", width: '100%', justifyContent: "space-between" }}>
              
                <div style={{ width: "25%" }}>
                    <Button className="btn btn-outline-danger" onClick={handleRemoveLiveStockAll} style={{ fontSize: 12, height: 35, background: "transparent", color: COLOR_APP_CANCEL }}>ລົບທັ້ງໝົດ</Button>
                </div>
            </div>
            <Table
                responsive
                style={{
                    marginTop: "20px",
                    borderCollapse: "collapse",
                    width: "100% ",
                }}>
                <thead >
                    <tr style={{ whiteSpace: 'nowrap' }}>
                        <th style={{ borderBottom: "none" }}>ຮູບ</th>
                        <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ</th>
                        <th style={{ borderBottom: "none" }}>ຈໍານວນ</th>
                        {/* <th style={{ borderBottom: "none" }}>ສະຖານະ</th> */}
                        <th style={{ borderBottom: "none" }}>ລາຄາ</th>
                        <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                    </tr>
                </thead>
                <tbody>
                    {liveStock.length > 0 && liveStock.map((lStock, index) =>
                        <tr key={lStock + index} style={{ whiteSpace: 'nowrap' }}>
                            <td>
                                <img src={imageRender(lStock?.image)} style={{
                                    borderRadius: 5,
                                    height: 40,
                                    width: 40,
                                }} />
                            </td>
                            <td>{lStock?.stock?.name} ({lStock?.cfMessage ?? ""})</td>
                            <td><div style={{ color: "#828282", background: '#fff', display: "flex", justifyContent: "space-around", paddingLeft: 5, paddingRight: 5, alignItems: "center", borderRadius: 8 }}>
                                <FontAwesomeIcon onClick={(e) => _liveStockChange(lStock, index, e, true)} icon={faMinus} color="#101010" />
                                <div style={{ margin: "0px 5px" }}>
                                    {lStock?.amount ?? ""}
                                </div>
                                <FontAwesomeIcon onClick={(e) => _liveStockChange(lStock, index, e, false)} icon={faPlus} color="#101010" />
                            </div></td>
                            <td>{new Intl.NumberFormat("en-US").format(lStock?.stock?.price ?? lStock?.price ?? 0)} {lStock?.stock?.currency ?? lStock?.currency ?? ""}</td>
                            <td><div style={{ marginLeft: 10 }}>
                                <div onClick={() => removeStockFromLive(lStock)} style={{ width: 35, height: 35, borderRadius: 8, background: "#EEE", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginRight: 10 }}>
                                    <FontAwesomeIcon icon={faTrash} color={COLOR_APP_CANCEL} />
                                </div>
                            </div></td>
                        </tr>
                    )}
                </tbody>
            </Table>

           

        </div>
    )
}
